/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum EquipmentType {
    Primary = 0,
    Secondary = 1,
    Support = 2,
}
